import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'
import { BENEFITS_KEY_OVERRIDES } from 'helpers/benefits-key-overrides'

function remapBenefitItem(item) {
  return convertKeysToPascalCase(item, BENEFITS_KEY_OVERRIDES)
}

export const remapBenefitsGetResponse = (data) => ({
  Benefits: (data.benefits ?? data.Benefits ?? []).map(remapBenefitItem),
  WaivedBenefits: (data.waivedBenefits ?? data.WaivedBenefits ?? []).map(
    remapBenefitItem
  ),
})
